module.exports = __webpack_public_path__ + "static/media/holdup.abd5ae81.png";